module.exports = __webpack_public_path__ + "img/1229686329.d08307ea.jpg";